import MyServicesResponsive from './MyServicesResponsive';

export default MyServicesResponsive;